import { Injectable } from '@angular/core';
import { Rotas } from '@core/enums/routes';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import {
	EnvioDadosMassivosHidrologicos,
	EnvioDadosMassivosMeteorologicos,
} from '@modulos/home/submodulos/dados-meteorologicos/interfaces/envio-dados-massivo';
import { MensagemEnvioDadosResponse } from '@modulos/home/submodulos/dados-meteorologicos/submodulos/monitoramento/interfaces/monitoramento-estacoes';

@Injectable({
	providedIn: 'root',
})
export class DadosMassivosService {
	constructor(private http: HttpClientProtectedService) {}

	solicitarEnvioDadosMassivosMeteorologicos({
		nome,
		email,
		tipoEstacao,
		periodo,
		variaveis,
		estacoes,
		dataInicio,
		dataFim,
	}: EnvioDadosMassivosMeteorologicos) {
		return this.http.post<
			EnvioDadosMassivosMeteorologicos,
			MensagemEnvioDadosResponse
		>(Rotas.DADOS_MASSIVOS + '/meteorologicos', {
			nome,
			email,
			tipoEstacao,
			periodo,
			variaveis,
			estacoes,
			dataInicio,
			dataFim,
		});
	}

	solicitarEnvioDadosMassivosHidrologicos({
		nome,
		email,
		periodo,
		dataInicio,
		dataFim,
		reservatorios,
		tipoReservatorio,
	}: EnvioDadosMassivosHidrologicos) {
		return this.http.post<
			EnvioDadosMassivosHidrologicos,
			MensagemEnvioDadosResponse
		>(Rotas.DADOS_MASSIVOS + '/hidrologicos', {
			nome,
			email,
			tipoReservatorio,
			periodo,
			dataInicio,
			dataFim,
			reservatorios,
		});
	}
}
